
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from "@components/seo";
import parse from "html-react-parser";
import type { GetStaticProps, NextPage } from "next/types";
import { PAGE } from "../consts/ppages";
import { getPageById } from "../utils/get-page";
interface IPage {
    page: {
        title: string;
        content: string;
    };
}
const PrivacyPolicy: NextPage<IPage> = ({ page }) => (<>
    <NextSeo languageAlternates={[
        { href: "https://knsokna.pl/privacy-policy", hrefLang: "x-default" },
        { href: "https://knswindows.com/privacy-policy", hrefLang: "en" },
        { href: "https://knsokna.pl/privacy-policy", hrefLang: "pl" },
        { href: "https://knsfenster.de/privacy-policy", hrefLang: "de" },
        { href: "https://kns-okna.eu/privacy-policy", hrefLang: "cs" },
        { href: "https://knsfinestre.it/privacy-policy", hrefLang: "it" },
        { href: "https://knsfenetres.fr/privacy-policy", hrefLang: "fr" },
        { href: "https://knsokna.eu/privacy-policy", hrefLang: "hu" },
    ]}/>
    <div className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
        <h1 className="font-bold text-2xl">{page?.title}</h1>
        <div>{parse(page?.content || "")}</div>
      </div>
    </div>
  </>);
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || "PL";
    const LOCALE = locale === "cz" ? "CS" : locale.toUpperCase();
    const PAGE_ID = PAGE.PRIVACY[LOCALE as keyof typeof PAGE.PRIVACY] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default PrivacyPolicy;

    async function __Next_Translate__getStaticProps__1a19cd2bee6__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacy-policy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a19cd2bee6__ as getStaticProps }
  